$(document).ready(function() {
  
  $(document).on('keyup', '.cart-notes-textbox', function() {
    var cart_note = $.trim($('.cart-notes-textbox').val());
        $.ajax({
          url: '/cart/update.js',
          dataType: 'json',
          type: 'POST',
          data: {
              note: cart_note
          },
          success: function(data) {
              console.log(data);
          }
        });
  });
    
    $(document).on('keyup', '.gift-message-textbox', function() {
        // Use $(this) to get the value from the specific textarea
        var gift_message = $.trim($(this).val());
    
        console.log('Current gift message:', gift_message);
    
        $.ajax({
          url: '/cart/update.js',
          dataType: 'json',
          type: 'POST',
          data: {
            attributes: {
              'gift_message': gift_message
            }
          },
          success: function(data) {
            console.log('Gift message updated:', data);
            // Optionally, provide feedback to the user
          },
          error: function(xhr, status, error) {
            console.error('Error updating gift message:', error);
            // Optionally, handle the error case
          }
        });
      });

  $(document).on('keyup', '.cart-notes-textbox-mobile', function() {
    var cart_note = $.trim($('.cart-notes-textbox-mobile').val());
        $.ajax({
          url: '/cart/update.js',
          dataType: 'json',
          type: 'POST',
          data: {
              note: cart_note
          },
          success: function(data) {
              console.log(data);
          }
        });
  });

  $(document).on('keyup', '.gift-message-textbox-mobile', function() {
      var gift_message_mobile = $.trim($('.gift-message-textbox-mobile').val());
      console.log(gift_message_mobile);
      $.ajax({
        url: '/cart/update.js',
        dataType: 'json',
        type: 'POST',
        data: {
          attributes: {
            'gift_message_mobile': gift_message_mobile
          }
        },
        success: function(data) {
          console.log('Gift message updated:', data);
          // You can add any additional UI updates here, like showing a success message
        },
        error: function(xhr, status, error) {
          console.error('Error updating gift message:', error);
          // Optionally handle errors here
        }
      });
  });


  $(document).on('keyup', '.cart-page-gift-message-textbox-mobile', function() {
      var gift_message_cart_page_mobile = $.trim($(this).val());
  
      console.log('Current gift message:', gift_message_cart_page_mobile);
  
      $.ajax({
        url: '/cart/update.js',
        dataType: 'json',
        type: 'POST',
        data: {
          attributes: {
            'gift_message_cart_page_mobile': gift_message_cart_page_mobile
          }
        },
        success: function(data) {
          console.log('Gift message updated:', data);
          // Optionally, add UI feedback here
        },
        error: function(xhr, status, error) {
          console.error('Error updating gift message:', error);
          // Optionally, handle errors here
        }
      });
    });


    $(document).on('keyup', '.cart-page-notes-textbox', function() {
    var cart_note = $.trim($('.cart-page-notes-textbox').val());
        $.ajax({
          url: '/cart/update.js',
          dataType: 'json',
          type: 'POST',
          data: {
              note: cart_note
          },
          success: function(data) {
              console.log(data);
          }
        });
  });
  

  $(document).on('keyup', '.cart-page-gift-message-textbox', function() {
    // Use $(this) to get the value from the specific textarea
    var gift_message = $.trim($(this).val());

    console.log('Current gift message:', gift_message);

    // Perform the AJAX request to update the cart attributes
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'POST',
      data: {
        attributes: {
          'gift_message_cart_page_desktop': gift_message
        }
      },
      success: function(data) {
        console.log('Gift message updated:', data);
        // Optionally, add UI feedback here
      },
      error: function(xhr, status, error) {
        console.error('Error updating gift message:', error);
        // Optionally, handle errors here
      }
    });
  });


$(document).on('click', '.cart-note-tab', function () {
  const tabId = $(this).data('tab'); // Get the tab ID from the data attribute
  const tabPane = $('#' + tabId); // Target the corresponding tab-pane

  if ($(this).hasClass('active')) {
    // If the tab is already active, close it smoothly
    $(this).removeClass('active');
    tabPane.stop(true, true).slideUp(300).removeClass('active');
  } else {
    // Deactivate all other tabs and panes smoothly
    $('.cart-note-tab').removeClass('active');
    $('.tab-pane.active').stop(true, true).slideUp(300).removeClass('active');

    // Activate the clicked tab and its corresponding pane smoothly
    $(this).addClass('active');
    tabPane.stop(true, true).slideDown(300).addClass('active');
  }
});




    
});